export const GOOGLE_MAPS_CONFIG = {
    googleMapsApiKey: 'AIzaSyBbWNUj6lb2RpS4j5Dk45l_v_FOgLHfAF4',
    libraries: ['places'],
    id: 'script-loader',
};
